// Whether this browser has ever held a SIMSM session.
//
// The 401 interceptor needs it to tell apart two states that look identical on
// the wire. A session that expired while the reader was working is worth saying
// out loud ("Sesiunea a expirat", caiet UC10-06's sibling state); an address
// typed or bookmarked with no session at all is not an expiry, and telling that
// reader their session expired would be a sentence the system knows to be false
// (FR-014). The first goes to /auth/session-expired, the second to the landing
// page — which is where that reader was headed anyway.
//
// A flag, not the session itself: the session token is an HttpOnly cookie this
// code cannot read, and must not be able to.
const ESTABLISHED_KEY = 'simsm.session.established';

export function markSessionEstablished(): void {
  try {
    window.localStorage.setItem(ESTABLISHED_KEY, 'true');
  } catch {
    /* a private-mode browser still gets a working app, it just gets the
       landing page instead of the expiry screen */
  }
}

export function clearSessionEstablished(): void {
  try {
    window.localStorage.removeItem(ESTABLISHED_KEY);
  } catch {
    /* see above */
  }
}

export function hasHeldSession(): boolean {
  try {
    return window.localStorage.getItem(ESTABLISHED_KEY) === 'true';
  } catch {
    return false;
  }
}
